import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

import { CounterpartyLimitViewModel, LimitCustomPropertyData, LimitCustomPropertyValue } from '../../CounterpartyLimits.component.model';

@Component({
    selector: 'app-limit-custom-property',
    templateUrl: './limit-custom-property.component.html',
    styleUrls: ['./limit-custom-property.component.css'],
    standalone: false
})
export class LimitCustomPropertyComponent implements OnChanges {//CRD-408-Pawan Prajapati
  @Input() __sPortalDateFormat: string;
  @Input() __oCounterpartyLimit: CounterpartyLimitViewModel;
  @Output() getCustomPropertyUpdated = new EventEmitter<any>();
  @Output() getCustomPropertyCancelled = new EventEmitter<boolean>();
  @Input() __bVisible: boolean = false;
  @Input() __oLimitCustomProperties: LimitCustomPropertyData[] = [];


  ngOnChanges(changes: SimpleChanges) {
    if (changes["__oCounterpartyLimit"] && changes["__oCounterpartyLimit"].currentValue) {
      this.loadControls();
    }
  }

  loadControls() {
    try {
      if (this.__oLimitCustomProperties) {
        for (var __oLimitCustomPropertyItem of this.__oLimitCustomProperties) {
          var oItem = this.__oCounterpartyLimit.LimitCustomPropertyValues.find(k => k.lLimitCustomPropertyId == __oLimitCustomPropertyItem.lLimitCustomPropertyId)
          __oLimitCustomPropertyItem.Value = oItem ? oItem.Value : '';
          __oLimitCustomPropertyItem.lCounterpartyLimitId = this.__oCounterpartyLimit.lCounterpartyLimitId;

          if (__oLimitCustomPropertyItem.LimitCustomPropertyDataType == 'Uri') {
            this.ReferenceTextBoxLostFocus(__oLimitCustomPropertyItem.lLimitCustomPropertyId);
          } else if (__oLimitCustomPropertyItem.LimitCustomPropertyDataType == 'True/False') {
            __oLimitCustomPropertyItem.Value = oItem ? oItem.Value == "true" : false;
          } else if (__oLimitCustomPropertyItem.LimitCustomPropertyDataType == 'Numeric' || __oLimitCustomPropertyItem.LimitCustomPropertyDataType == 'Money') {
            __oLimitCustomPropertyItem.Value = oItem && oItem.Value ? parseFloat(oItem.Value) : '';
          }
          
          if (!__oLimitCustomPropertyItem.Value && __oLimitCustomPropertyItem.DefaultValue) {
            __oLimitCustomPropertyItem.Value = __oLimitCustomPropertyItem.DefaultValue
          }
        }
      }
    } catch (oError) {
      throw oError;
    }
  }

  public onKeyPressNumberBoxState(e: any, lLimitCustomPropertyId: any) {
    try {
      let oCustomPropertyData: LimitCustomPropertyData = this.__oLimitCustomProperties.find(x => x.lLimitCustomPropertyId == lLimitCustomPropertyId);
      if (e.event.key == 'm' || e.event.key == "M") {
        oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000;
      }
      else if (e.event.key == "b" || e.event.key == "B") {
        oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000000000;
      }
      else if (e.event.key == "k" || e.event.key == "K") {
        oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
      }
      else if (e.event.key == "h" || e.event.key == "H") {
        oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 100;
      }
      else if (e.event.key == "t" || e.event.key == "T") {
        oCustomPropertyData.Value = parseFloat(e.event.target.value.toString().replace(",", "").replace(",", "").replace(",", "").replace(",", "")) * 1000;
      }
    } catch (oError) {
      throw oError;
    }
  }

  public ReferenceTextBoxLostFocus(lLimitCustomPropertyId: any) {
    try {
      let oCustomPropertyData: LimitCustomPropertyData = this.__oLimitCustomProperties.find(x => x.lLimitCustomPropertyId == lLimitCustomPropertyId);
      if (oCustomPropertyData.Value && oCustomPropertyData.Value.replace(/ /g, '')) {
        oCustomPropertyData.ReferenceDataTextBoxVisible = 0;
        oCustomPropertyData.ReferenceDataURLVisible = 1;
      } else {
        oCustomPropertyData.ReferenceDataTextBoxVisible = 1;
        oCustomPropertyData.ReferenceDataURLVisible = 0;
      }
    } catch (oError) {
      throw oError;
    }
  }

  public OpenReferenceDataURL(lLimitCustomPropertyId: any) {
    try {
      let oCustomPropertyData: LimitCustomPropertyData = this.__oLimitCustomProperties.find(x => x.lLimitCustomPropertyId == lLimitCustomPropertyId);
      window.open(oCustomPropertyData.Value, "_blank");
    } catch (oError) {
      throw oError;
    }
  }

  private copyMessage(val: string){
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  public EditReferenceData(lLimitCustomPropertyId: any) {
    try {
      let oCustomPropertyData: LimitCustomPropertyData = this.__oLimitCustomProperties.find(x => x.lLimitCustomPropertyId == lLimitCustomPropertyId);
      oCustomPropertyData.ReferenceDataTextBoxVisible = 1;
      oCustomPropertyData.ReferenceDataURLVisible = 0;
    } catch (oError) {
      throw oError;
    }
  }

  btnApply_Click() {
    try {
      this.__bVisible = false;
      this.__oCounterpartyLimit.CustomPropertyEntityState = (this.__oCounterpartyLimit.LimitCustomPropertyValues && this.__oCounterpartyLimit.LimitCustomPropertyValues.length > 0) ? 2 : 1;
      this.__oCounterpartyLimit.LimitCustomPropertyValues = [];
      for (var __oLimitCustomPropertyItem of this.__oLimitCustomProperties) {
        var oLimitCustomPropertyValue = new LimitCustomPropertyValue();
        if (this.__oCounterpartyLimit.CustomPropertyEntityState == 1) {
          oLimitCustomPropertyValue.lLimitCustomPropertyValueId = this.generateUniqueKey();
        }
        oLimitCustomPropertyValue.lLimitCustomPropertyId = __oLimitCustomPropertyItem.lLimitCustomPropertyId;
        oLimitCustomPropertyValue.lTradingLimitId = __oLimitCustomPropertyItem.lCounterpartyLimitId;
        oLimitCustomPropertyValue.Value = __oLimitCustomPropertyItem.Value?.toString();
        this.__oCounterpartyLimit.LimitCustomPropertyValues.push(oLimitCustomPropertyValue);
      }
      this.getCustomPropertyUpdated.emit(this.__oCounterpartyLimit);
    } catch (oError) {
      throw oError;
    }
  }
  public generatedNumbers = [];
  public generateUniqueKey() {
    let number;
    do {
      number = Math.floor(Math.random() * 1000000) + 5000000;
    } while (this.generatedNumbers.includes(number));
    this.generatedNumbers.push(number);
    return number;
  }
  btnCancel_Click() {
    try {
      this.__bVisible = false;
      this.getCustomPropertyCancelled.emit(false);
    } catch (oError) {
      throw oError;
    }
  }
}
